import { render, staticRenderFns } from "./UserDetailsView.vue?vue&type=template&id=758e6fb5&scoped=true"
import script from "./UserDetailsView.vue?vue&type=script&lang=ts"
export * from "./UserDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./UserDetailsView.vue?vue&type=style&index=0&id=758e6fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758e6fb5",
  null
  
)

export default component.exports